var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',{staticClass:"locale-select",attrs:{"items":_vm.locales,"dense":"","item-text":"title","item-value":"value"},on:{"change":function($event){return _vm.$router.go()}},model:{value:(_vm.$root.$i18n.locale),callback:function ($$v) {_vm.$set(_vm.$root.$i18n, "locale", $$v)},expression:"$root.$i18n.locale"}})
}
var staticRenderFns = []

export { render, staticRenderFns }